import { validatedFormatData } from '../model/dataFormats';

export type ValidatedFormat = typeof validatedFormatData[number];

interface IGetValidatedFormats {
    formats?: string[];
    exclude?: ValidatedFormat[];
    replaceWithFormats?: string[];
}

/**
 * Возвращает список форматов:
 * - по умолчанию берёт validatedFormatData
 * - добавляет formats
 * - если replaceWithFormats задан, он заменяет validatedFormatData
 * - затем удаляет exclude
 */
export const getValidatedFormats = ({
    formats = [],
    exclude = [],
    replaceWithFormats = [],
}: IGetValidatedFormats = {}) => {
    const base = replaceWithFormats.length > 0 ? replaceWithFormats : validatedFormatData;

    const combined = new Set<string>([...base, ...formats]);

    exclude.forEach((format) => combined.delete(format));
    return Array.from(combined);
};
